// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import WipPartReturn from '@deere/cps-it.warranty-model-factory/lib/wip-return-parts';
import WipPartReturnItem from './wip-item';

const WipPartReturns = props =>
    <div className='wip-part-returns'>
        <WipPartReturnItem
            className={props.wipPartReturns.partsToReturn > 0 ? 'dot-icon-red' : ''}
            count={props.wipPartReturns.partsToReturn}
            status='OPEN_PART_REQUESTS'
        />
    </div>;

WipPartReturns.displayName = 'WipPartReturns';
WipPartReturns.propTypes = {
    wipPartReturns: PropTypes.instanceOf(WipPartReturn).isRequired
};

export default WipPartReturns;



// WEBPACK FOOTER //
// ./src/home-page/components/wip-part-returns.js